var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrideLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1178,
    height: 375,
    viewBox: "0 0 1178 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_4077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.03516 289.737L78.046 274.906C79.3057 297.81 98.2588 309.262 122.194 309.262C137.425 309.262 148.132 305.54 149.793 296.894C151.854 284.927 142.807 277.941 102.382 272.158C36.8187 262.71 20.7285 226.808 28.5731 181.458C36.4178 138.169 73.1216 112.746 138.284 112.746C215.356 112.746 236.37 149.85 240.493 191.077L164.223 206.309C162.161 183.404 153.114 174.128 129.179 174.128C112.288 174.128 103.24 179.511 101.981 187.355C100.32 196.803 102.782 205.507 150.194 212.493C218.906 222.8 231.847 261.565 224.632 301.99C216.787 345.68 182.145 372.478 112.86 372.478C29.8329 372.191 6.29899 333.025 3.03516 289.737Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 5.72602,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.703 118.643H394.007L381.639 188.729H316.706L285.384 366.236H210.946L242.267 188.729H177.334L189.703 118.643Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 5.72602,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.049 283.151H418.572L403.684 366.007H329.246L372.993 118.643H483.448C546.949 118.643 579.129 154.488 569.338 211.805C563.154 247.65 544.602 267.061 516.544 276.109L559.031 365.205V366.007H473.141L442.049 283.151ZM435.865 184.607L428.363 225.319H467.129C485.681 225.319 494.384 219.593 496.389 208.141C499.309 190.963 490.663 184.664 473.484 184.664L435.865 184.607Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 5.72602,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.793 366.007L570.483 118.643H644.921L601.232 366.007H526.793Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 5.72602,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.584 118.643H737.569C830.387 118.643 862.109 171.38 847.279 255.495C836.113 320.256 782.976 366.007 708.71 366.007H589.895L633.584 118.643ZM696.57 180.484L674.582 304.166H705.102C746.73 304.166 768.088 283.953 774.788 246.906C783.434 198.636 767.745 180.541 725.315 180.541L696.57 180.484Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 5.72602,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.566 118.643H1133.18L1120.81 188.729H896.407L891.826 213.466H1006.35L996.441 269.924H881.92L877.339 295.921H1101.8L1089.43 366.007H790.819L834.566 118.643Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 5.72602,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.62 210.832C556.798 173.613 564.127 153.572 558.287 141.604C552.904 130.152 535.669 124.426 503.603 116.238L487.971 112.344L504.119 112.001C582.279 110.455 594.246 103.87 646.41 34.2414L658.721 17.7505L650.075 36.36C632.897 73.5792 625.567 93.6201 631.408 105.645C636.733 117.097 654.312 122.823 686.034 131.011L701.666 134.905L685.576 135.248C607.416 136.795 595.449 143.322 543.285 213.008L530.974 229.441L539.62 210.832Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.127 35.501C614.516 107.878 617.722 116.181 685.518 132.843C606.499 134.447 594.245 141.146 541.566 211.462C575.178 139.142 571.971 130.839 504.118 114.119C583.194 112.573 595.448 105.874 648.127 35.501V35.501ZM669.314 0L644.692 32.9246C592.585 102.553 582.049 108.279 504.061 109.825L471.823 110.512L503.087 118.299C534.523 126.144 551.358 132.042 556.339 142.52C561.779 153.972 554.679 173.326 537.672 209.973L520.494 247.249L545.116 214.325C597.223 144.754 607.759 138.97 685.747 137.424L717.928 136.794L686.663 128.95C655.285 121.105 638.45 115.207 633.411 104.786C627.685 93.334 635.129 73.9226 652.135 37.3334L669.314 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1118.75 313.9V298.44H1177.67V357.361H1162.21V324.779L1122.99 364.003L1112.05 353.123L1151.27 313.9H1118.75Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_4077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1177.67,
    height: 374.997,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrideLogo);
export default __webpack_public_path__ + "static/media/stride-logo.e7c4615cb684589441be61cbabee48f7.svg";
export { ForwardRef as ReactComponent };